<template>
  <StarRating
    ref="starRating"
    v-model="modelValue"
    v-bind="{
      maxRating,
      readOnly,
      fixedPoints: digits,
      starSize: size,
      increment: step,
    }"
    :class="{ disabled }"
  />
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
  name: 'AppRatingStars',

  components: {
    StarRating,
  },

  props: {
    onBeforeChange: {
      type: Function,
      required: false,
    },

    size: {
      type: Number,
      default: 20,
    },

    digits: {
      type: Number,
    },

    readOnly: {
      type: Boolean,
      default: true,
    },

    maxRating: {
      type: Number,
      default: 5,
    },

    step: {
      type: Number,
      default: 1,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modelValue: {
      get() {
        return this.$attrs.modelValue
      },

      async set(newValue) {
        const oldValue = this.$attrs.modelValue

        if (newValue === oldValue) return

        const { onBeforeChange } = this

        if (onBeforeChange) {
          const result = await onBeforeChange({ newValue, oldValue })

          if (result === false) {
            const starRating = this.$refs.starRating

            if (starRating)
              starRating.currentRating = starRating.selectedRating = oldValue

            return
          }
        }

        if (newValue !== oldValue) {
          this.$emit('update:modelValue', newValue)
          this.$emit('change', { newValue, oldValue })

          await this.$nextTick()

          this.$emit('afterChange', { newValue, oldValue })
        }
      },
    },
  },
}
</script>
